<!--
@负责人: 黎柏祺
@创建时间: 2018-12-05
@版本:v1.0.26
@描述: 日志分析页-离线任务
-->
<template>
  <div class="offlineTask__content">
    <div class="offlineTask__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('logAnalysis.time')">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
          {{$t('common.to')}}
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('logAnalysis.indexName')">
          <el-input v-model="form.indexName" :placeholder="$t('logAnalysis.placeholderRemain')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('logAnalysis.taskName')">
          <el-input v-model="form.taskName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_searchOffline" v-g-rac="gRac('logAnalysisOffline_search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
      <el-button type="text" v-text="kibanaBtnText" @click="e_kibanaClick"></el-button>
    </div>
    <div class="offlineTask__table">
      <el-table-extend
      :data="tData" 
      :head="tHead"
      :currentChange="tCurrentChange"
      :sizeChange="tSizeChange"
      border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <div class="mt-base" v-show="task_detail.length">
        <div v-text="$t('logAnalysis.taskDetail')" class="mt-base mb-base"></div>
        <dynamic-table 
          ref="dynamicTable" 
          :input-data="tableData" 
          :model="tableModel"  
          :is-add="isAdd" 
          :is-operation="isOperation">
        </dynamic-table>
      </div>
    </div>
    <dialog-form
      key="kibanaEdit"
      :title="$t('logAnalysis.kibanaEdit')" 
      :size="1" 
      :label-size="1" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :cancel-fun="e_cancel"
      :confirm-fun="e_kibanaSave">
    </dialog-form>
  </div>
</template>
<script>
  import LogAnalysisBiz from '@/logic/logRetrieve/logRetrieveBiz.js'
  import validateConfig from '@/utils/validate'
  import table from '@/components/mixins/table'
  import dic from '@/components/mixins/dic'
  import rac from '@/plugins/rac-mixin.js'
  import dynamicTable from '@/components/dynamicTable'
  import { extend, getKeyByValue } from '@/utils/tool'
  import dialogForm from '@/components/dialogForm'
  import TimeFormat from '@/utils/timeFormat'
  const A_WEEK = 86400000 * 7

  export default {
    mixins: [dic, rac, table],
    components: {
      dynamicTable,
      dialogForm
    },
    data () {
      const that = this
      return {
        form: {
          startTime: '',
          endTime: '',
          indexName: '',
          taskName: ''
        },
        tableControl: [{
          label: that.$t('common.delete'),
          callback: that.e_delete,
          rac: () => that.gRac('logAnalysisOffline_detail')
        },
        {
          label: that.$t('common.check'),
          callback: that.e_check,
          rac: () => that.gRac('logAnalysisOffline_detail')
        },
        {
          label: that.$t('logAnalysis.jump'),
          callback: that.e_jump,
          rac: () => that.gRac('logAnalysisOffline_detail')
        }],
        kibanaBtnText: '',
        logTaskStatus: {},
        logDLStatus: {},
        logUploadStatus: {},
        dialogFormShow: false,
        dialogModel: {
          userName: '',
          password: ''
        },
        dialogData: [],
        dialogFormRule: {
          userName: [{ ...validateConfig.common.notEmpty }],
          password: [{ ...validateConfig.common.notEmpty }]
        },
        task_detail: [],
        offlineSelect: {},
        tableData: [],
        tableModel: {},
        isOperation: false,
        isAdd: false
      }
    },
    methods: {
      init () {
        this.form.startTime = new Date().getTime() - 86400000
        this.form.endTime = new Date().getTime()
        this.getKibanaAccount()
        this.waitLogDLStatus()
        this.waitLogTaskStatus()
        this.waitLogUploadStatus()
        this.setDynamicData()
        this.setDialogData()
      },
      async waitLogTaskStatus () {
        await this.dGetDictionaryByCode('logTaskStatus')
        this.logTaskStatus = { ...this.dDictionary.logTaskStatus }
      },
      async waitLogDLStatus () {
        await this.dGetDictionaryByCode('logDLStatus')
        this.logDLStatus = { ...this.dDictionary.logDLStatus }
        this.initTable()
        this.searchOffline()
      },
      async waitLogUploadStatus () {
        await this.dGetDictionaryByCode('logUploadStatus')
        this.logUploadStatus = { ...this.dDictionary.logUploadStatus }
      },
      initTable () {
        this.tInitTable({
          lanKey: 'logAnalysis.table',
          head: ['createTime', 'loginCustomerName', 'indexName', 'taskName', 'totalSize', 'status'],
          requestFun: this.searchOffline,
          headOpt: {
            'status': {
              formatter: 'Dictionary',
              formatterDic: this.dDictionary.logDLStatus
            }
          }
        })
      },
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('logAnalysis.username'),
            key: 'userName'
          },
          {
            label: this.$t('logAnalysis.password'),
            key: 'password'
          }
        ]
      },
      setDynamicData () {
        this.tableData = [
          {
            label: this.$t('logAnalysis.fileName'),
            type: 'text',
            key: 'key'
          },
          {
            label: this.$t('logAnalysis.fileSize'),
            key: 'logSize',
            type: 'text'
          },
          {
            label: this.$t('logAnalysis.downloadStatus'),
            key: 'logDownloadStatus',
            type: 'text'
          },
          {
            label: this.$t('logAnalysis.importStatus'),
            key: 'logImportStatus',
            type: 'text'
          }
        ]
      },
      getKibanaAccount () {
        LogAnalysisBiz.getKibanaAccount().then((data) => {
          this.kibanaBtnText = `${this.$t('logAnalysis.kibanaButton')}：${data.userName}/${data.password}`
        })
      },
      validateForTips ({startTime, endTime, appName, indexName}) {
        let res = false
        if (startTime >= endTime) {
          res = this.lan.timeAlert
        } else if (endTime > startTime + A_WEEK) {
          res = this.lan.timeIntervalAlert
        } else if (appName && typeof appName !== 'string') {
          res = this.lan.appNameAlert
        } else if (indexName && !(/^[a-z0-9d-]*$/.test(indexName))) {
          res = this.lan.indexNameAlert
        }

        return res
      },
      e_searchOffline () {
        this.tResetPage()
        this.searchOffline()
      },
      searchOffline () {
        let validateRes = false
        if (this.form.startTime >= this.form.endTime) {
          validateRes = this.$t('logAnalysis.timeAlert')
        }

        validateRes = this.validateForTips({
          indexName: this.form.indexName
        })

        if (validateRes) {
          this.$message({
            message: validateRes,
            type: 'warning'
          })
        } else {
          const reqData = extend(true, { ...this.tPageInfo }, this.form)
          LogAnalysisBiz.getOfflineTask(reqData).then((data) => {
            data.dataList.map((item) => {
              item.totalSize = item.totalSize.toFixed(2)
              item.createTime = TimeFormat.getFormatTime(item.createTime)
            })
            this.tData = data
          })
        }
      },
      e_check (rowData) {
        this.offlineSelect = {...rowData}
      },
      e_delete (rowData) {
        if (getKeyByValue(this.logDLStatus, rowData.status) === 'DONE') {
          const deleteInfo = {
            indexName: rowData.indexName,
            taskName: rowData.taskName
          }
          this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
            type: 'warning'
          }).then(() => {
            LogAnalysisBiz.deleteOfflineTask(deleteInfo).then((data) => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              setTimeout(() => {
                this.task_detail = []
                this.$refs.dynamicTable.setData(this.task_detail)
                this.e_searchOffline()
              }, 600)
            })
          }).catch(() => {

          })
        } else {
          this.$message({
            message: this.$t('logAnalysis.doneAlert'),
            type: 'warning'
          })
        }
      },
      e_jump (rowData) {
        if (getKeyByValue(this.logDLStatus, rowData.status) === 'DONE') {
          window.open('http://kibana2.ucloudlink.com')
        }
      },
      e_clearTable () {
        this.table_download = []
      },
      e_kibanaClick () {
        this.dialogFormShow = true
      },
      e_cancel () {
        this.dialogFormShow = false
      },
      e_kibanaSave (data) {
        LogAnalysisBiz.saveKibanaAccount(data).then((data) => {
          this.getKibanaAccount()
          this.dialogModel = {
            userName: '',
            password: ''
          }
          this.dialogFormShow = false
        })
      }
    },
    mounted () {
      this.init()
    },
    watch: {
      offlineSelect () {
        this.task_detail = []
        for (let i = 0; i < this.offlineSelect.logList.length; i++) {
          for (const j in this.logUploadStatus) {
            if (this.offlineSelect.logList[i].logImportStatus === j) {
              this.offlineSelect.logList[i].logImportStatus = this.logUploadStatus[j]
            }
          }
          for (const j in this.logDLStatus) {
            if (this.offlineSelect.logList[i].logDownloadStatus === j) {
              this.offlineSelect.logList[i].logDownloadStatus = this.logDLStatus[j]
            }
          }
        }
        this.task_detail = this.offlineSelect.logList
        this.$refs.dynamicTable.setData(this.task_detail)
      }
    }
  }
</script>
